export default "__VITE_ASSET__Buv0eIh6__"